var Component = require("!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./curd.vue"),
  /* template */
  require("!!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-2b4e5d04!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./curd.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/xelement/curd.vue
// module id = 51
// module chunks = 2